import { INestedInputLevel } from './INestedInputLevel';

/**
 * Helper function for creating input names for the nested input structure.
 *
 * The generated input name can of type:
 * - id: Generate an input name that can be used for an input field that stores the id of the element
 * - selected: Generate an input name that can be used for an input field that stores the selected child(ren) id(s) of the element
 */
export function getNestedInputName(
	level: INestedInputLevel,
	type: 'id' | 'selected',
) {
	const prefixWithParentOnly = type !== 'id';
	const prefix = getNestedInputNamePrefix(level, prefixWithParentOnly);

	return `${prefix}.${type}`;
}

function getNestedInputNamePrefix(
	level: INestedInputLevel,
	parentOnly: boolean,
) {
	let name = `ancillaryGroups[${level.ancillaryGroupIndex}]`;

	if (
		!('ancillaryIndex' in level) ||
		(parentOnly && !('extraIndex' in level))
	) {
		return name;
	}

	name = `${name}.ancillaries[${level.ancillaryIndex}]`;

	if (
		!('extraIndex' in level) ||
		(parentOnly && !('extraVariantIndex' in level))
	) {
		return name;
	}

	name = `${name}.extras[${level.extraIndex}]`;

	if (!('extraVariantIndex' in level) || parentOnly) {
		return name;
	}

	return `${name}.variants[${level.extraVariantIndex}]`;
}
